import { render } from "./NewsNotices.vue?vue&type=template&id=6cde8034&scoped=true"
import script from "./NewsNotices.vue?vue&type=script&lang=js"
export * from "./NewsNotices.vue?vue&type=script&lang=js"

import "./NewsNotices.vue?vue&type=style&index=0&id=6cde8034&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cde8034"]])

export default __exports__